import { bulkPlanning } from "../../../../networking/urlmanager";
import axios from 'axios'
/**
 * Save planned orders with vehicle assignments
 * @param {string} token - Authentication token
 * @param {Object} bulkAndVehicleData - {bulkId , plaque , driverTC , driverName , dorse , stateId , isActive , rowId}
 * @returns {Promise<Object>} - The response data
 */
export const addVehicleExtraTour = async (token, bulkAndVehicleData) => {
    try {
        const response = await axios.post(
            bulkPlanning.addExtraTourVehicle,
            { ...bulkAndVehicleData },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error saving Vehicles Extra Tour:', error);
        throw error;
    }
};

export const deleteBulkPlanning = async (token, data) => {

    try {
        const response = await axios.post(
            bulkPlanning.delete,
            { ...data },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error saving Vehicles Extra Tour:', error);
        throw error;
    }
};

export const completePlanning = async (token, data) => {
    
    try {
        const response = await axios.post(
            bulkPlanning.completePlanning,
            { ...data },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error saving Vehicles Extra Tour:', error);
        throw error;
    }
};

export const getAllPlanning = async (token, params) => {
    
    try {
        const response = await  axios.get(
            bulkPlanning.getAll, {
                params,
                headers: {
                  Authorization: "Bareer " + token,
                },
              }
        );

        return response.data.data;
    } catch (error) {
        console.error('Error saving Vehicles Extra Tour:', error);
        throw error;
    }
};
